import { Component } from '@angular/core';

/**
 * Privacy page
 *
 * @export
 * @class PrivacyComponent
 */
@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class PrivacyComponent { }
